import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import AnimatedLogo from './AnimatedLogo';
import Magnetic from './ux/Magnetic';

const { FiCommand, FiGithub, FiLinkedin, FiTwitter } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-white dark:bg-slate-950 border-t border-slate-100 dark:border-slate-800 pt-16 md:pt-20 pb-8 md:pb-10 relative z-10 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-6 text-center md:text-left">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-16 mb-12 md:mb-16">
          <div className="md:col-span-2 flex flex-col items-center md:items-start">
            <Magnetic>
              <Link to="/" className="inline-flex items-center gap-2 mb-6 md:mb-8" data-cursor="hover">
                <AnimatedLogo />
                <span className="text-slate-900 dark:text-white font-bold text-xl tracking-wider">
                  AETRIX LOGIC
                </span>
              </Link>
            </Magnetic>
            <p className="text-slate-600 dark:text-slate-400 mb-8 max-w-sm leading-relaxed">
              Architecting enterprise-grade software systems and AI integrations for businesses that demand performance, precision, and global scale.
            </p>
            <div className="flex gap-4">
              <Magnetic strength={0.4}>
                <a href="https://www.linkedin.com/company/aetrixlogic" target="_blank" rel="noopener noreferrer" className="w-12 h-12 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-800 flex items-center justify-center text-slate-500 hover:text-cyan-600 hover:border-cyan-600 dark:hover:border-cyan-500 transition-all shadow-sm" data-cursor="hover">
                  <SafeIcon icon={FiLinkedin} />
                </a>
              </Magnetic>
            </div>
          </div>

          <div>
            <h4 className="text-slate-900 dark:text-white font-bold uppercase tracking-widest text-xs mb-6">Expertise</h4>
            <ul className="space-y-4">
              <li><Link to="/services" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">Custom Software</Link></li>
              <li><Link to="/services" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">AI & Machine Learning</Link></li>
              <li><Link to="/services" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">.NET Development</Link></li>
              <li><Link to="/services" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">Azure Cloud</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-slate-900 dark:text-white font-bold uppercase tracking-widest text-xs mb-6">Company</h4>
            <ul className="space-y-4">
              <li><Link to="/about" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">About Us</Link></li>
              <li><Link to="/capabilities" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">Capabilities</Link></li>
              <li><Link to="/contact" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">Contact</Link></li>
              <li><Link to="/careers" className="text-sm text-slate-600 dark:text-slate-400 hover:text-cyan-600 dark:hover:text-cyan-400 transition-colors" data-cursor="hover">Careers</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-100 dark:border-slate-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-slate-500 dark:text-slate-400 text-sm font-medium">
            © 2026 Aetrix Logic. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-6 md:gap-8">
            <Link to="/privacy-policy" className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors" data-cursor="hover">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-[10px] md:text-xs font-bold uppercase tracking-widest text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 transition-colors" data-cursor="hover">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;